const currencyFormatter = (x: number) => {
    return parseFloat(x || 0 as any).toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
}

export default currencyFormatter;
